// 20261021 受注注文の締切（毎月末）と発送予定（締切から2か月以内＝翌々月末）を日本時間で計算して表示・カート項目に入れる
// 予約は締切日を過ぎていたら「受付終了」に切り替える（ページのキャッシュで日付をまたいだとき用）
// 受注はサイズを切り替えたとき、受注になるサイズかどうかで案内枠・カートに渡す項目・ボタンの文言を切り替える
// （20261027 サイズの色分けとその説明、受注時の紺のボタンはやめた）
// 20261102 URLにサイズの指定がなければサイズ未選択で開く（buy-buttons.liquid）。そのときは name="id" が空なので受注の案内は出ない
// 20261027 数量は1点ずつ。在庫のあるONのサイズは、カート内の通常の行の数が在庫に達したら受注に切り替える
(function () {
  const WEEKDAYS_JA = ['日', '月', '火', '水', '木', '金', '土'];
  const MONTHS_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function todayInTokyo() {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Tokyo',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    }).formatToParts(new Date());
    const get = (type) => Number(parts.find((p) => p.type === type).value);
    return { year: get('year'), month: get('month'), day: get('day') };
  }

  // month は1始まり。monthOffset か月後の月末日を返す
  function monthEnd(year, month, monthOffset) {
    const date = new Date(Date.UTC(year, month - 1 + monthOffset + 1, 0));
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate(),
      weekday: date.getUTCDay(),
    };
  }

  function update(box) {
    const isJa = box.dataset.locale === 'ja';
    const now = todayInTokyo();
    const deadline = monthEnd(now.year, now.month, 0);
    const leadMonths = Number(box.dataset.leadMonths) || 2;
    const ship = monthEnd(now.year, now.month, leadMonths);

    let deadlineShort, deadlineFull, shipText;
    if (isJa) {
      deadlineShort = `${deadline.month}月${deadline.day}日（${WEEKDAYS_JA[deadline.weekday]}）23:59まで`;
      deadlineFull = `${deadline.year}年${deadline.month}月${deadline.day}日`;
      shipText = `${ship.year}年${ship.month}月${ship.day}日までに発送`;
    } else {
      deadlineShort = `${MONTHS_EN[deadline.month - 1]} ${deadline.day}, ${deadline.year} 23:59 (JST)`;
      deadlineFull = `${MONTHS_EN[deadline.month - 1]} ${deadline.day}, ${deadline.year}`;
      shipText = `By ${MONTHS_EN[ship.month - 1]} ${ship.day}, ${ship.year}`;
    }

    const deadlineEl = box.querySelector('[data-preorder-deadline]');
    const shipEl = box.querySelector('[data-preorder-ship]');
    if (deadlineEl) deadlineEl.textContent = deadlineShort;
    if (shipEl) shipEl.textContent = shipText;

    const inputs = {
      deadline: deadlineFull,
      ship: shipText.replace('までに発送', 'まで'),
      month: `${deadline.year}-${String(deadline.month).padStart(2, '0')}`,
    };
    box.querySelectorAll('[data-preorder-input]').forEach((input) => {
      input.value = inputs[input.dataset.preorderInput];
    });
  }

  function closeIfPassed(box) {
    const deadline = box.dataset.deadline;
    if (!deadline) return;
    const now = todayInTokyo();
    const today = `${now.year}-${String(now.month).padStart(2, '0')}-${String(now.day).padStart(2, '0')}`;
    if (today <= deadline) return;

    const open = box.querySelector('[data-preorder-open]');
    const closed = box.querySelector('[data-preorder-closed]');
    if (open) open.hidden = true;
    if (closed) closed.hidden = false;

    const form = box.closest('form');
    const button = form && form.querySelector('[name="add"]');
    if (button) {
      button.setAttribute('data-preorder-closed', '');
      button.dataset.addLabel = box.dataset.closedLabel;
      button.setAttribute('disabled', 'disabled');
      const label = button.querySelector('span');
      if (label) label.textContent = box.dataset.closedLabel;
    }
  }

  function updateAll() {
    document.querySelectorAll('[data-preorder-box="juchu"]').forEach(update);
    document.querySelectorAll('[data-preorder-box="yoyaku"]').forEach(closeIfPassed);
  }

  // 20261027 カート内の通常の行（受注・予約の印がない行）の数をサイズごとに数える
  let cartNormalQty = {};
  function refreshCart() {
    const url = `${(window.routes && window.routes.cart_url) || '/cart'}.js`;
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        const counts = {};
        (cart.items || []).forEach((item) => {
          const props = item.properties || {};
          if (props['_受注月'] || props['_予約']) return;
          counts[item.variant_id] = (counts[item.variant_id] || 0) + item.quantity;
        });
        cartNormalQty = counts;
      })
      .catch(() => {});
  }

  // 受注になるサイズ：在庫0以下のサイズ＋在庫のあるONのサイズのうちカートに入れた数で在庫を使い切ったもの
  function juchuIds(box) {
    const ids = (box.dataset.juchuVariants || '').split(',').filter(Boolean);
    (box.dataset.juchuStock || '').split(',').forEach((pair) => {
      const [id, stock] = pair.split(':');
      if (!id) return;
      if ((cartNormalQty[id] || 0) >= Number(stock)) ids.push(id);
    });
    return ids;
  }

  function currentVariantId(box) {
    const form = box.closest('form');
    const input = form && form.querySelector('[name="id"]');
    return input ? input.value : null;
  }

  function applyVariant(sectionId, variantId) {
    document.querySelectorAll('[data-preorder-box="juchu"]').forEach((box) => {
      const productForm = box.closest('product-form');
      if (sectionId && productForm && productForm.dataset.sectionId !== sectionId) return;

      const ids = juchuIds(box);
      const isJuchu = variantId != null && ids.includes(String(variantId));
      box.hidden = !isJuchu;
      box.querySelectorAll('input').forEach((input) => {
        input.disabled = !isJuchu;
      });

      const form = box.closest('form');
      const button = form && form.querySelector('[name="add"]');
      if (!button) return;
      button.dataset.addLabel = isJuchu ? box.dataset.preorderLabel : box.dataset.normalLabel;
      const label = button.querySelector('span');
      // 売り切れで押せないときは「売り切れ」の表示のままにする
      if (label && !button.hasAttribute('disabled')) label.textContent = button.dataset.addLabel;
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const data = event && event.data;
      if (!data) return;
      applyVariant(data.sectionId, data.variant ? data.variant.id : null);
    });
    // カートに入れた・カートから外したあとは、カートの中身を読み直して受注の切り替えをやり直す
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      refreshCart().then(applyCart);
    });
  }

  function applyCart() {
    document.querySelectorAll('[data-preorder-box="juchu"]').forEach((box) => {
      const productForm = box.closest('product-form');
      applyVariant(productForm ? productForm.dataset.sectionId : null, currentVariantId(box));
    });
  }

  updateAll();
  refreshCart().then(applyCart);
  window.addEventListener('load', updateAll);
  // サイズ切り替えやアプリで商品フォームが描き直されたときも入れ直す
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      document.querySelectorAll('[data-preorder-box="juchu"]').forEach((box) => {
        const input = box.querySelector('[data-preorder-input="month"]');
        if (input && !input.value) update(box);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
  // ページを開いたまま月をまたいでも、カートに入れる瞬間の日付で入れ直す
  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('.product-form__submit')) updateAll();
    },
    true
  );
})();
